export default __webpack_public_path__ + "static/media/Previous.16bb8002.svg";